/*
 * Copyright (c) Akveo 2019. All Rights Reserved.
 * Licensed under the Single Application / Multi Application License.
 * See LICENSE_SINGLE_APP / LICENSE_MULTI_APP in the 'docs' folder for license information on type of purchased license.
 */

import { Injectable } from '@angular/core';
import { Observable, of } from 'rxjs';
import { BillServiceWiseReportApi } from '../api/bill-service-wise-report.api';
import { BillServiceWiseReportData, BillServiceWiseReport } from '../../../interfaces/report/bill-service-wise-report';

@Injectable()
export class BillServiceWiseReportService extends BillServiceWiseReportData {

  constructor(private api: BillServiceWiseReportApi) {
    super();
  }



  list(url: string): Observable<BillServiceWiseReport[]> {
    return this.api.list(url);
  }

  getById(url:string): Observable<BillServiceWiseReport>{
      return this.api.getById(url);
  }

  create(url: string, data:BillServiceWiseReport): Observable<BillServiceWiseReport> {
    return this.api.add(url,data);
  }

  update(url: string, data:BillServiceWiseReport): Observable<BillServiceWiseReport> {
    return this.api.update(url,data);
  }
 

  delete(url: string): Observable<boolean> {
    return this.api.delete(url);
  }

  searchList(url: string,data:any): Observable<any> { 
   
    return this.api.searchList(url,data);
  }
}
